import { useState   ,useContext} from "react";

import { AuthContext } from "../util/api";

export default function SocialLinks() {

    const { info } = useContext(AuthContext);

    

    const [blogs, setBlogs] = useState([
        { id: 1, title: "WhatApp", content: "Join Our whatApp Group"  , link : info.whats_group_link },
        { id: 2, title: "Youtube", content: "Join Our Youtube Channel" , link : info.youtube },
        { id: 3, title: "Facebook", content: "Connect with us on Facebook" , link : info.facebook }
    ]);
   





    return (

        <>
      

            <div className="card fade-in">
                <h3>Join Our Social Links</h3>
                <div className="blog-list">
                    {blogs.map(blog => (
                        <div key={blog.id} className="blog-item">
                            <h4>{blog.title}</h4>
                            <p>{blog.content}</p>
                            <button onClick={() => window.open(blog.link, "_blank")}>Join</button>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}